export default {
  periodoVigencia: {
    id: null,
    nome: '',
    dataInicio: null,
    dataFim: null,
    ativo: true,
  },
  listPeriodoVigencia: [],
}
